const CLIENTS = [
  "Distrito Perseverancia",
  "Fastwash",
  "Tecmaq",
  "Todos Somos Corredores",
  "Nexus",
  "CM Arquitectura",
  "Imusa",
  "El Divino",
  "Blue Ocean",
];

export const Clients = () => {
  // Duplicate the list so the ticker at -50% loops seamlessly.
  const items = [...CLIENTS, ...CLIENTS];
  return (
    <section
      id="clientes"
      data-testid="clients-section"
      className="relative border-t border-divider bg-black"
    >
      <div className="grid grid-cols-12 items-baseline gap-6 px-6 md:px-10 pt-10 md:pt-14 pb-6">
        <div className="col-span-12 md:col-span-3 font-mono text-[10px] uppercase tracking-[0.25em] text-rust">
          [02·B] Clientes
        </div>
        <div className="col-span-12 md:col-span-9 font-mono text-[11px] uppercase tracking-[0.2em] text-white/50">
          Marcas y proyectos que confiaron en nuestra mirada.
        </div>
      </div>

      <div className="relative overflow-hidden py-8 md:py-12">
        <div className="ticker-track flex items-center gap-12 md:gap-20 whitespace-nowrap w-max">
          {items.map((name, i) => (
            <span
              key={`${name}-${i}`}
              className="flex items-center gap-12 md:gap-20 shrink-0"
            >
              <span
                className="font-display uppercase text-white tracking-[-0.02em] leading-none text-[7vw] md:text-[5vw] lg:text-[4.4vw] whitespace-nowrap hover:text-rust transition-colors duration-300"
                data-testid={`client-${i % CLIENTS.length}`}
              >
                {name}
              </span>
              <span
                aria-hidden="true"
                className="inline-block w-2.5 h-2.5 md:w-3.5 md:h-3.5 rounded-full bg-rust shrink-0"
              />
            </span>
          ))}
        </div>
      </div>

      <div className="border-t border-divider" />
    </section>
  );
};
